import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = 'https://gallopai.app';

const NOINDEX_PATH_PREFIXES = ['/dashboard', '/today-races', '/results', '/open-bets', '/today-bets', '/performance', '/settings', '/admin'];

function isNoIndexPath(pathname: string): boolean {
  return NOINDEX_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export const SeoDefaults: React.FC = () => {
  const location = useLocation();

  const pathname = location.pathname || '/';
  const canonical = useMemo(() => `${SITE_ORIGIN}${pathname === '/' ? '/' : pathname}`, [pathname]);
  const noindex = isNoIndexPath(pathname);

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:url" content={canonical} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
    </Helmet>
  );
};

